import { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import SwipeableViews from 'react-swipeable-views';
import { useDispatch } from 'react-redux';
import HOC from '../../HOC';
import { Video } from '../../../activities';
import { saveInteraction } from '../../../helpers/gamification';
import { trackEvent } from '../../../helpers/common';
import ProgressIndicator from '../../../common/ProgresIndicator';
import { syncState } from '../../../helpers/iframeHelper';
import { other } from '../../../redux/actions';

const Title = styled.h3`
  margin-bottom: 10px;
`;

const Container = styled.div`
  width: 82%;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: white;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 4px;
  padding-bottom: 20px;
`;

const LM = ({
  location,
  discoveryData,
  updateDiscoveryData,
  accountId,
  setHeaderState,
  viewedEducationData,
  quizData
}) => {
  const dispatch = useDispatch();
  const { state } = location;
  const allLMData = Object.values(discoveryData?.learningModules[state.lmIndex]) || null;
  const viewedLearningModules = viewedEducationData?.learningModules || [];
  const sortedLearningModules = allLMData
    .sort((a, b) => viewedLearningModules.includes(a?.activityId)
      - viewedLearningModules.includes(b?.activityId));

  const [swipeIndex, setSwipeIndex] = useState(
    sortedLearningModules.findIndex((i) => i.activityId === state.activityId)
  );
  const doneRf = (id) => {
    const newData = discoveryData.learningModules[state.lmIndex][id];
    newData.done = true;
    updateDiscoveryData({
      ...discoveryData,
      learningModules: discoveryData?.learningModules.map((item, index) => {
        if (index === state.lmIndex) {
          return { ...item, [id]: newData };
        }
        return item;
      })
    });
    saveInteraction({
      type: 'LM',
      state: newData.activityId
    });
    syncState();
  };

  const windowRef = useRef(window);

  useEffect(() => {
    windowRef.current.scrollTo(0, 0);
    if (sortedLearningModules) {
      trackEvent('DZ_LM_LAND', {
        lm_id: sortedLearningModules[swipeIndex].id,
        activity_id: sortedLearningModules[swipeIndex].activity.coachable_id,
        lesson_oidx: sortedLearningModules[swipeIndex].oidx,
        lesson_last: sortedLearningModules[swipeIndex].isLastItem
      });
      setHeaderState({
        lm_id: sortedLearningModules[swipeIndex].id,
        activity_id: sortedLearningModules[swipeIndex].activity.coachable_id,
        lesson_oidx: sortedLearningModules[swipeIndex].oidx,
        lesson_last: sortedLearningModules[swipeIndex].isLastItem
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swipeIndex]);

  const startVideoRequest = async () => {
    trackEvent('DZ_LM_VIDEO_START', {
      activity_id: sortedLearningModules[swipeIndex].activity.coachable_id,
      lesson_oidx: sortedLearningModules[swipeIndex].oidx,
      lesson_last: sortedLearningModules[swipeIndex].isLastItem,
      campaign_id: sortedLearningModules[swipeIndex].id,
      lm_id: sortedLearningModules[swipeIndex].id
    });
  };

  const endVideoRequest = async () => {
    trackEvent('DZ_LM_VIDEO_END', {
      activity_id: sortedLearningModules[swipeIndex].activity.coachable_id,
      lesson_oidx: sortedLearningModules[swipeIndex].oidx,
      lesson_last: sortedLearningModules[swipeIndex].isLastItem,
      campaign_id: sortedLearningModules[swipeIndex].id,
      lm_id: sortedLearningModules[swipeIndex].id,
    });
  };

  useEffect(() => {
    dispatch(other.setNotificationData({}));
  }, []);

  return (
    <div>
      {sortedLearningModules ? (
        <>
          <SwipeableViews
            index={swipeIndex}
            onChangeIndex={(i) => {
              setSwipeIndex(i);
            }}
            enableMouseEvents
            animateHeight
          >
            {sortedLearningModules.map((item) => (
              <div style={{ paddingBottom: '25px' }}>
                <Container>
                  <Title>{item.title}</Title>
                  <Video
                    data={item.activity}
                    setHeaderState={setHeaderState}
                    id={item.activityId}
                    swipeIndex={swipeIndex}
                    setSwipeIndex={setSwipeIndex}
                    onDone={doneRf}
                    accountId={accountId}
                    lessonData={allLMData}
                    startVideoRequest={startVideoRequest}
                    endVideoRequest={endVideoRequest}
                    isLearningModuleVideo
                    hasQuiz={quizData?.lmQuiz[state.lmIndex].length > 0}
                  />
                </Container>
              </div>

            ))}
          </SwipeableViews>
          <ProgressIndicator
            data={sortedLearningModules}
            index={swipeIndex}
            setIndex={setSwipeIndex}
            accessibilityLabel="Recycling Fundamentals"
          />
        </>

      ) : null}
    </div>
  );
};

export default HOC(LM);
